<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />
    <HeadingOne>お客さま情報の確認・変更</HeadingOne>

    <section>
      <HeadingTwo class="_mt-50">お客さま情報</HeadingTwo>
      <TableBox class="_mb-md-60 _mb-sm-30">
        <TableBody>
          <TableRow>
            <TableHeader>
              お客さま番号
              <TooltipsItem placement="righttop" clazz="question-box">
                ※お問い合わせの際にオペレーターに伝えていただく番号です。
              </TooltipsItem>
            </TableHeader>
            <TableData>
              {{ userData.account_id }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>
              氏名<small>（漢字）</small>
              <TooltipsItem placement="righttop" clazz="question-box">
                ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
              </TooltipsItem>
            </TableHeader>
            <TableData>
              {{ coveredName }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader>
              氏名<small>（フリガナ）</small>
              <TooltipsItem placement="righttop" clazz="question-box">
                ご結婚などにより改姓した場合は、コールセンターへご連絡ください。
              </TooltipsItem>
            </TableHeader>
            <TableData>
              {{ coveredNameKana }}
            </TableData>
          </TableRow>
          <!-- <TableRow>
            <TableHeader> 生年月日 </TableHeader>
            <TableData>
              {{ displayBth(userData.bth) }}
            </TableData>
          </TableRow> -->
          <!--<TableRow>
            <TableHeader>
              性別
            </TableHeader>
            <TableData>
              {{displaySex}}
            </TableData>
          </TableRow>-->
          <TableRow v-if="auUser(userData.id_type) && hasPhoneAu">
            <TableHeader>
              au携帯電話番号または<br />UQ mobile 電話番号
            </TableHeader>
            <TableData>
              {{
                displayPhoneAu(
                  coveredWithMark(userData.phone_au_1),
                  coveredWithMark(userData.phone_au_2),
                  userData.phone_au_3
                )
              }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> 電話番号<small>（その他）</small> </TableHeader>
            <TableData>
              {{
                displayPhoneMobile(
                  hasPhoneMobile,
                  coveredWithMark(userData.phone_mobile_1),
                  coveredWithMark(userData.phone_mobile_2),
                  userData.phone_mobile_3
                )
              }}
            </TableData>
          </TableRow>
          <!--<TableRow>-->
          <!--<TableHeader>-->
          <!--au PAY プリペイドカード-->
          <!--<btn-tooltip slot="tooltip" target="mailTooltip" class="-question"></btn-tooltip>-->
          <!--<TooltipsItem slot="tooltip" target="mailTooltip" placement="righttop" clazz="question-box">-->
          <!--ご利用中のau PAY プリペイドカード情報については、<br /><a href="https://wallet.auone.jp/index.html" target="_blank">au PAY サイト</a>をご確認ください。-->
          <!--</TooltipsItem>-->
          <!--</TableHeader>-->
          <!--<TableData>-->
          <!--登録あり-->
          <!--</TableData>-->
          <!--</TableRow>-->
          <TableRow>
            <TableHeader> 毎月のご返済日 </TableHeader>
            <TableData>
              毎月{{ userData.contractual_repayment_cycle }}日
              <!--{{displayRepaymentDate}}-->
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <CardGroups class="_mb-md-60 _mb-sm-30">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion1" class="-plus">
              <h3 class="heading">ご自宅情報</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion1" accordion="accordion">
            <CardBody>
              <BtngroupSingle class="-pcnone _mb-md-40 _mb-sm-20">
                <!--<BtnMain class="-normal" router-name="mb024">-->
                <BtnMain class="-normal" router-name="mb024">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
              <TableBox class="_mb-md-20 _mb-sm-10">
                <TableBody>
                  <TableRow>
                    <TableHeader> 郵便番号 </TableHeader>
                    <TableData>
                      〒{{ coveredPostCode }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> ご住所<small>（漢字）</small> </TableHeader>
                    <TableData>
                      {{
                          coveredAddress+
                          userData.address_street+
                          coveredWithMark(userData.address_building)
                      }}
                    </TableData>
                  </TableRow>
                  <!-- <TableRow>
                    <TableHeader>
                      ご住所<small>（フリガナ）</small>
                    </TableHeader>
                    <TableData>
                      {{ userData.address_kana }}
                    </TableData>
                  </TableRow> -->
                  <TableRow>
                    <TableHeader> お住まいの種類 </TableHeader>
                    <TableData>
                      {{ displayHomeType(userData.home_type) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 居住開始年月 </TableHeader>
                    <TableData>
                      {{ displayNkyNgt(userData.nky_ngt) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader>
                      住宅ローンもしくは家賃のお支払い<small>（月額）</small>
                    </TableHeader>
                    <TableData>
                      {{ displayRentLoanAmount(userData.rent_loan_amount) }}
                    </TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
              <TableBox class="_mb-md-60 _mb-sm-30">
                <TableBody>
                  <TableRow>
                    <TableHeader> ご家族（配偶者さま） </TableHeader>
                    <TableData>
                      {{ displayMarriageStatus(userData.marriage_status) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> ご家族（お子さま） </TableHeader>
                    <TableData>
                      {{ displayNumberOfChildren(userData.number_of_children) }}
                    </TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
              <BtngroupSingle class="_mb-md-40 _mb-sm-20">
                <!--<BtnMain class="-normal" router-name="mb024">-->
                <BtnMain class="-normal" router-name="mb024">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>

      <HeadingTwo class="_mt-50">メールアドレス情報</HeadingTwo>
      <CardGroups class="_mb-md-60 _mb-sm-30">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion2" class="-plus">
              <h3 class="heading">メールアドレス・お知らせ通知設定</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion2" accordion="accordion">
            <CardBody>
              <BtngroupSingle class="-pcnone _mb-md-40 _mb-sm-20">
                <BtnMain class="-normal" router-name="mb026">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
              <TableBox>
                <TableBody>
                  <template
                    v-if="
                      showDefaultMail(
                        userData.ez_mail,
                        userData.mail_1,
                        userData.mail_2
                      )
                    "
                  >
                    <TableRow>
                      <TableHeader rowspan="3">
                        メールアドレス※
                        <!-- vue2で表示されないため -->
                        <!-- <TooltipsItem target="mailTooltip" placement="righttop" clazz="question-box">
                          au IDにご登録の連絡先メールアドレスを表示しております。<br />変更をご希望の場合は、<a href="https://id.auone.jp/" class="-underline">au IDサイト</a>にて連絡先メールアドレスをご登録ください。
                        </TooltipsItem> -->
                      </TableHeader>
                      <TableData>
                        {{ coveredMail(displayEzMail(userData.ez_mail)) }}
                      </TableData>
                    </TableRow>
                    <TableRow>
                      <TableData>
                        {{ coveredMail(displayMail1(userData.mail_1)) }}
                      </TableData>
                    </TableRow>
                    <TableRow>
                      <TableData>
                        {{ coveredMail(displayMail2(userData.mail_2)) }}
                      </TableData>
                    </TableRow>
                  </template>
                  <TableRow>
                    <TableHeader> メールアドレス </TableHeader>
                    <TableData>
                      {{ coveredMail(displayLoanMail(userData.loan_mail)) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> お知らせ通知設定 </TableHeader>
                    <TableData>
                      現在ご登録いただいているお知らせ通知設定を表示しています。<br />
                      <template v-if="userData.cpn_ukt_flg === '1'"
                        >・キャンペーン情報<br
                      /></template>
                      <template v-if="userData.kri_tti_ukt_flg === '1'"
                        >・お借り入れ時<br
                      /></template>
                      <template v-if="userData.hen_soku_ukt_flg === '1'"
                        >・ご返済時<br
                      /></template>
                      <template v-if="userData.mns_stm_ukt_flg === '1'"
                        >・マンスリーステートメント発行<br
                      /></template>
                    </TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
              <div class="_mb-md-60 _mb-sm-30">
                <small
                  >※au
                  IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a
                    href="https://id.auone.jp/"
                    class="btn-text textlink"
                    target="_blank"
                    >au IDサイト</a
                  >にて連絡先メールアドレスをご登録ください。</small
                >
              </div>
              <BtngroupSingle class="_mb-md-40 _mb-sm-20">
                <!--<BtnMain class="-normal" router-name="mb026">-->
                <BtnMain class="-normal" router-name="mb026">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
      <HeadingTwo class="_mt-50">お勤め先情報</HeadingTwo>
      <CardGroups class="_mb-md-120 _mb-sm-60">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion3" class="-plus">
              <h3 class="heading">お勤め先情報</h3>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion3" accordion="accordion">
            <CardBody>
              <BtngroupSingle class="-pcnone _mb-md-40 _mb-sm-20">
                <!--<BtnMain class="-normal" router-name="mb025">-->
                <BtnMain class="-normal" router-name="mb025">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
              <TableBox class="_mb-md-60 _mb-sm-30">
                <TableBody>
                  <TableRow>
                    <TableHeader> 職業 </TableHeader>
                    <TableData>
                      {{ displayWorkForm(userData.work_form) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 業種 </TableHeader>
                    <TableData>
                      {{ displayBizType(userData.biz_type) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 職種 </TableHeader>
                    <TableData>
                      {{ displayJobType(userData.job_type) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> お勤め先 </TableHeader>
                    <TableData>
                      {{ coveredOffice_nm }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> お勤め先電話番号 </TableHeader>
                    <TableData>
                      {{
                        displayOfficePhone(
                          coveredWithMark(userData.office_phone_1),
                          coveredWithMark(userData.office_phone_2),
                          userData.office_phone_3
                        )
                      }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 所属部署 </TableHeader>
                    <TableData>
                      {{ userData.office_depart }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 入社年月 </TableHeader>
                    <TableData>
                      {{ displayNshNgt(userData.nsh_ngt) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader> 社員数 </TableHeader>
                    <TableData>
                      {{ displayStaffNum(userData.staff_num) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableHeader>
                      年収（税込）
                      <TooltipsItem placement="righttop" clazz="question-box">
                        ※収入証明書をご提出いただいた場合、書類の確認結果によって年収が更新されることがあります。
                      </TooltipsItem>
                    </TableHeader>
                    <TableData>
                      {{ displayGrossSalary(userData.gross_salary) }}
                    </TableData>
                  </TableRow>
                </TableBody>
              </TableBox>
              <BtngroupSingle class="_mb-md-40 _mb-sm-20">
                <!--<BtnMain class="-normal" router-name="mb025">-->
                <BtnMain class="-normal" router-name="mb025">
                  変更する
                </BtnMain>
                <div class="_mt-md-20 _mt-sm-20">
                  <small>
                    ※4桁暗証番号認証後、SMS認証がございます。
                  </small>
                </div>
              </BtngroupSingle>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import {
  getUserDataLambdaInvoke,
  deleteTmpUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import {
  setHasPhoneAu,
  setHasPhoneMobile,
  displayBth,
  auUser,
  displayPhoneAu,
  displayPhoneMobile,
  displayPostcode,
  displayAddress,
  displayHomeType,
  displayJkyNgt,
  displayNkyNgt,
  displayRentLoanAmount,
  displayMarriageStatus,
  displayNumberOfChildren,
  showDefaultMail,
  displayEzMail,
  displayMail1,
  displayMail2,
  displayLoanMail,
  displayWorkForm,
  displayBizType,
  displayJobType,
  displayStaffNum,
  displayNshNgt,
  displayOfficePhone,
  displayGrossSalary,
} from "@/utils/UserData";

import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import CardGroups from "@/components/card/CardGroups";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CardBox from "@/components/card/CardBox";
import BtnToggle from "@/components/button/BtnToggle";
import CollapseItem from "@/components/collapse/CollapseItem";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb023",
  components: {
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    HeadingTwo,
    TooltipsItem,
    CardGroups,
    CardHeader,
    CardBody,
    CardBox,
    BtnToggle,
    CollapseItem,
    BtnMain,
    BtngroupSingle,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お客さま情報の確認・変更｜ご登録情報",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      displayBth,
      auUser,
      displayPhoneAu,
      displayPhoneMobile,
      displayPostcode,
      displayAddress,
      displayHomeType,
      displayJkyNgt,
      displayNkyNgt,
      displayRentLoanAmount,
      displayMarriageStatus,
      displayNumberOfChildren,
      showDefaultMail,
      displayEzMail,
      displayMail1,
      displayMail2,
      displayLoanMail,
      displayWorkForm,
      displayBizType,
      displayJobType,
      displayStaffNum,
      displayNshNgt,
      displayOfficePhone,
      displayGrossSalary,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          active: true,
        },
      ],
      hasPhoneMobile: false,
      hasPhoneAu: false,
      userData: {
        id_type: "",
        account_id: "",
        name_kanji: "",
        name_kana: "",
        lastname_kanji: "",
        firstname_kanji: "",
        lastname_kana: "",
        firstname_kana: "",
        bth: "",
        sex: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        repayment_date: "",
        contractual_repayment_cycle: "",
        // ご自宅情報
        postcode: "",
        address_region: "",
        address_city: "",
        address_street: "",
        address_building: "",
        address_kana: "",
        home_type: "",
        nky_ngt: "",
        rent_loan_amount: "",
        marriage_status: "",
        number_of_children: "",
        // メールアドレス情報
        ez_mail: "",
        mail_1: "",
        mail_2: "",
        loan_mail: "",
        cpn_ukt_flg: "",
        hen_soku_ukt_flg: "",
        kri_tti_ukt_flg: "",
        mns_stm_ukt_flg: "",
        // お勤め先情報
        work_form: "",
        biz_type: "",
        job_type: "",
        office_nm: "",
        office_phone_1: "",
        office_phone_2: "",
        office_phone_3: "",
        office_depart: "",
        nsh_ngt: "",
        staff_num: "",
        gross_salary: "",
      },
    };
  },
  computed: {
    coveredName() {
      const firstname = [...this.userData.firstname_kanji]
        .map((v, i) => {
          i++;
          if (i % 2 === 0) {
            return (v = "*");
          } else {
            return v;
          }
        })
        .join("");
      const lastname = [...this.userData.lastname_kanji]
        .map((v, i) => {
          i++;
          if (i % 2 !== 0) {
            return (v = "*");
          } else {
            return v;
          }
        })
        .join("");
      return lastname + "　" + firstname;
    },
    coveredNameKana() {
      const firstname = [...this.userData.firstname_kana]
        .map((v, i) => {
          if (i === 0) {
            return v;
          } else {
            return (v = "*");
          }
        })
        .join("");
      const lastname = [...this.userData.lastname_kana]
        .map((v, i) => {
          if (i === 1) {
            return v;
          } else {
            return (v = "*");
          }
        })
        .join("");
      return lastname + "　" + firstname;
    },
    coveredPostCode() {
      const code = [...displayPostcode(this.userData.postcode)]
        .map((v) => {
          return v;
        })
        .slice(3)
        .join("");
      return "***" + code;
    },
    coveredAddress() {
      const region = this.userData.address_region.length;
      const city = this.userData.address_city.length;
      const text = "*";
      return text.repeat(region + city);
    },
    coveredOffice_nm() {
      const office = [...this.userData.office_nm]
        .map((v, i) => {
          i++;
          if (i % 2 === 0) {
            return (v = "*");
          } else {
            return v;
          }
        })
        .join("");
      return office;
    },
  },
  mounted() {
    try {
      deleteTmpUserDataLambdaInvoke()
        .then(() => {})
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
    try {
      getUserDataLambdaInvoke().then((res) => {
        for (let key in res) {
          if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
            this.userData[key] = res[key].toString().trim();
          }
        }
        this.hasPhoneAu = setHasPhoneAu(
          this.userData.phone_au_1,
          this.userData.phone_au_2,
          this.userData.phone_au_3
        );
        this.hasPhoneMobile = setHasPhoneMobile(
          this.userData.phone_mobile_1,
          this.userData.phone_mobile_2,
          this.userData.phone_mobile_3
        );
        // }).catch(error => {
        // goToErrorPage(error)
      });
    } catch (e) {
      // goToErrorPage(e)
    }
  },
  methods: {
    coveredWithMark(mark) {
      const length = mark.length
      const text = "*";
      return text.repeat(length);
    },
    coveredMail(mail) {
      const index = mail.indexOf("@");
      if (index !== -1) {
        let newMail = [...mail]
          .map((v, i) => {
            if (i !== 0 && i < index - 1) {
              v = "*";
            }
            return v;
          })
          .join("");
        return newMail;
      } else {
        return mail;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.-underline {
  text-decoration: underline;
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
</style>
